import React, { useState } from 'react';
import NavBar from "../Navbar/NavBar";
import { useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, Button, CardMedia, IconButton, Link } from '@mui/material';
import { Share, ArrowBack, WhatsApp, Twitter, Facebook, LinkedIn, ContentCopy } from '@mui/icons-material';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from 'react-share';

const BeadsConceptNote = () => {
    const [comments, setComments] = useState([]);
    const [commentText, setCommentText] = useState("");
    const [shareOptionsVisible, setShareOptionsVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [newsletterMessage, setNewsletterMessage] = useState('');
    const [commentMessage, setCommentMessage] = useState('');
    const [showCopyMessage, setShowCopyMessage] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);

    const navigate = useNavigate();

    const handleCommentSubmit = (event) => {
        event.preventDefault();
        if (commentText.trim() !== '') {
            setComments([...comments, commentText]);
            setCommentText("");
            setCommentMessage('Comment submitted! Your comment has been submitted successfully');
            setTimeout(() => setCommentMessage(''), 4000);
        }
    };

    const handleNewsletterSubmit = (event) => {
        event.preventDefault();
        if (email.trim() !== '' && firstName.trim() !== '' && lastName.trim() !== '') {
            setEmail('');
            setFirstName('');
            setLastName('');
            setNewsletterMessage('Success. Please check your email to confirm.');
            setTimeout(() => setNewsletterMessage(''), 4000);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleShareClick = () => {
        setShareOptionsVisible(!shareOptionsVisible);
        setShowCopyMessage(true);
        setLinkCopied(false); // Reset copied status on new click
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            setLinkCopied(true);
            setTimeout(() => {
                setShowCopyMessage(false);
                setLinkCopied(false);
            }, 2000); // Hide the message after 2 seconds
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    };

    const shareUrl = window.location.href;
    const title = 'BEADS CONCEPT NOTE'


    // sharing handled by react-share components; no custom handler needed

    // Define the social media platforms with their corresponding components and icons
    const socialMediaPlatforms = [
        { name: 'WhatsApp', component: WhatsappShareButton, icon: WhatsApp },
        { name: 'Twitter', component: TwitterShareButton, icon: Twitter },
        { name: 'Facebook', component: FacebookShareButton, icon: Facebook },
        { name: 'LinkedIn', component: LinkedinShareButton, icon: LinkedIn },
    ];

    const iconStyles = {
        WhatsApp: {
            color: "#25D366", // WhatsApp color
        },
        Twitter: {
            color: "#1DA1F2", // Twitter color
        },
        Facebook: {
            color: "#1877F2", // Facebook color
        },
        LinkedIn: {
            color: "#0077b5", // LinkedIn color
        },
        // Add other platform colors as needed
    };

    return (
        <Box>
            <NavBar />
            <Box sx={{
                borderRadius: '1.5rem',
                mt: 5,
                maxWidth: '800px',
                mx: { xs: '1rem', sm: '4rem', md: '6rem', lg: '7rem' },
                p: { xs: 2, md: 2 }
            }}
            >
                <Typography variant="h4" component="h1" sx={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold', color: 'black', mt: 5 }}>
                    BEADS CONCEPT NOTE
                </Typography>

                <CardMedia
                    component="img"
                    image='https://res.cloudinary.com/self-hosted/image/upload/v1707713159/Beads/news/debbie_n0rbl5.jpg'
                    alt='debbie'
                    sx={{
                        borderRadius: '2rem',
                        mt: 2, width: '100%',
                        height: { xs: 'auto', md: '600px' },
                        objectFit: 'cover'
                    }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, fontSize: '0.875rem' }}>
                    <Typography component="span">Debby Rooney - CEO & FOUNDER BEADS for Education</Typography>
                    {/* <Typography component="span">Posted by: Debbie</Typography>
                    <Typography component="span"> February 27th 2020</Typography> */}
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    I am Debby Rooney, the Founder and CEO of BEADS for Education. BEADS is a 501©(3) non-profit based in the United States. Since 1998, we have been sponsoring girls’ education, mostly from the marginalized Maasai community in Kenya. 52 million girls in sub-Saharan Africa have never attended school. Our sponsored girls feel especially blessed to be enrolled in the BEADS high school. In the Maasai community, most parents do not have enough money to send their girls to high school. Many Maasai girls are forced into an arranged marriage as young as 13, to a 30 plus year old man, undergo female genital mutilation, become the  2nd or 3rd wife and  bear 7 or more children. Today, this is a sentence for a life of poverty. But young Maasai women who finish high school usually become the sole wife of a man she chooses, bear 3 or 4 children, provide a quality education for all her children, have an increased sense of dignity/self-esteem and escape female genital mutilation.
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    We educate about 230 students a year – 60 at our primary school (nursery – 4th grade), 100 at the BEADS High School, 20 completing the gap year, and 50 at various universities. We select girls based on financial need and merit. The applicants are recommended by our long-term contacts within the Maasai community.  Most of our girls are the first in their family to attend high school.
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    In 2013 we opened our own high school (Tembea Academy) to provide a quality education only available in expensive private schools in Kenya.  The typical Kenyan teaching methodology is rote memorization with the students parroting the answer verbatim. In contrast, our high school curriculum is based on critical thinking, reading, writing, interdisciplinary lessons, and student- centered hands-on activities. In the Kenyan curriculum, students only read 4 books during 9th through 12th grade. Our school library has an extensive collection of classic novels and reference materials. Our students read every day and participate in book clubs daily. Not only does this open the doors to the world but stimulates critical thinking and empathy for other people and cultures.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Our writing program includes the students interviewing their older relatives and preparing oral histories intended to help secure their cultural heritage. Students also journal daily and write short stories.
                    <br />
                    <Link href="http://www.ashoka.org" target="_blank" rel="noopener noreferrer" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                        Ashoka
                    </Link>
                    {' and '}
                    <Link href="http://www.worldreader.org" target="_blank" rel="noopener noreferrer" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                        Worldreader
                    </Link>
                    {' have selected 5 stories to publish from around the world. '}
                    <br />
                    <Box component="span" sx={{ fontWeight: 'bold' }}>Rebecca</Box>, our 11th grade student, was selected to represent Africa.
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    Girls apply to participate in special courses that enhance their talents.  Zoom has provided us with the opportunity to work with experts around the world. Presently a NYC Broadway producer and professor of screen writing is presenting an 8 week course on screen writing. Other similar courses include a Yale University architectural designer working with the girls on the basics of architectural design.
                    <br />
                    {' Another course is teaching the girls cinematography to enter the '}
                    <Link href="https://connectherfilmfest.org/" target="_blank" rel="noopener noreferrer" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                        ConnectHer
                    </Link>
                    {' film festival. '}
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>

                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Additionally, we enhance the curriculum to include subject matter overlooked in the Kenyan curriculum. e.g. wildlife, world history, famous people, most important inventions, food security and the best farming practices. A major goal is to teach the girls to live in harmony with the earth.  We raise most of our own food and farm totally organically.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>

                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    We emphasize the opportunities for girls to learn leadership skills. Three girls have been accepted by the Yale Young African Scholars leadership program.
                    One girl is an
                    <Link href="http://www.ashoka.org" target="_blank" rel="noopener noreferrer" sx={{ color: 'primary.main', fontWeight: 'bold' }}> Ashoka Junior Changemaker
                    </Link> and another a youth ambassador for
                    <Link href="http://www.hundred.org" target="_blank" rel="noopener noreferrer" sx={{ color: 'primary.main', fontWeight: 'bold' }}>HundrED
                    </Link>.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Our sponsorship program matches girls with sponsors throughout the world who are financially committed to support the girls’ education from high school through the university. Occasionally, a sponsor will request a girl attending primary school which we also accommodate. We are still seeking sponsorship for an additional 24 girls. Sponsors usually donate $1600 per year.  The parents are required to pay 10% of the school fees to demonstrate their commitment to their girl’s education. The sponsorship program usually lasts 9 years (there could be 2 extra years depending on the government’s criteria). Girls start with 4 years at our high school, a volunteer gap year and 4 years at a university.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    In order to qualify for a university sponsorship through BEADS, each girl volunteers during her gap year to teach at the BEADS’ primary school (nursery through 4th grade.). Our primary school is especially prized by the local community since the only other primary school in the area is a 2 hour walk – precluding many 4-6 year old children from attending school. During the gap year girls learn many skills which prepares them to be successful at the university.  Up to this point in their lives, girls have been supervised by parents and teachers 100% percent of the time. During the gap year they learn to make their own decisions, prepare work plans, keep their own time schedule and expand their educational opportunities.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Students at our high school, receive a mentor who guides her academics, helps her highlight her strengths/talents and to pursue them, and develop her self- confidence and self- esteem. The mentors help their girls design their volunteer projects to help solve problems in their communities.  Each girl does  this 3 times a year which enhances her commitment to her family, community and culture. This extends our outreach to 1000’s of people annually.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    We are an Ashoka Changemaker School, one of only 2 in Kenya.  We guide each girl to do her best to lead their school, family and community to live honorably and make positive changes to rectify the problems facing us in the 21st century.  One issue we address with Ashoka is climate change and how to address our carbon footprint.  The high school is totally solar powered. It is typical for an uneducated Maasai women to bear more than 10 children. And if each of her 10 children follows her example, by the 5th generation there will be 100,000 more children.  But an educated woman, like our college graduates, usually has 2 or 3 children and by the 5th generation there are only 32 new births.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    We are dedicated to developing strong character and fight corruption. We follow the honor code which requires girls not to cheat, steal or lie or abide by those that do. We do not proctor our girls’ exams.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    A girl’s mentor provides career counselling and guides her in her decisions regarding the selection of a university major. The goal is to epitomize student’s talents and define her personality traits. The mentor guides them to select a major that enables them to secure meaningful work focusing on their talents.  Each student completes personality profiles enabling them to determine their assets and personality traits.  They evaluate where they want to live, what work suits their personality and their special skills. Our graduates include doctors, nurses, teachers, accountants, geologist, nutritionists, cooks etc.  All our university students study in Kenya which ensures that there is no “brain drain” to other parts of the world.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Our college graduates are role models for their families, communities and girls attending our high school.  They are all committed to financially helping their families after graduation.  Parents who previously did not believe in sending their girls to the university are now so proud of their university graduates and insist their daughter is worth a bigger dowry than an uneducated girl.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    We have hosted over 30 “Coming of Age” ceremonies without the cut which ensures the culture is honored but eliminates the detrimental aspects of the practice. We have been very successful to mostly eradicate FGM in our Amboseli National Park region. We wish to expand this program to our newly established region in the Masai Mara.
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Our goal is to continue to rescue more Maasai girls from poverty by providing a quality education.
                </Typography>

                <Box sx={{ backgroundColor: '#f5f5f5', textAlign: 'center', mt: 2, pb: 3 }}>
                    <Box>
                        <IconButton onClick={handleShareClick}>
                            <Share />
                        </IconButton>
                        <Typography variant="caption" component="span" sx={{ verticalAlign: 'sub' }}>
                            Share
                        </Typography>
                    </Box>

                    {shareOptionsVisible && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
                            {socialMediaPlatforms.map((platform) => {
                                const ShareComponent = platform.component;
                                const Icon = platform.icon;
                                return (
                                    <ShareComponent key={platform.name} url={shareUrl} title={title}>
                                        <IconButton>
                                            <Icon style={iconStyles[platform.name]} />
                                        </IconButton>
                                    </ShareComponent>
                                );
                            })}
                        </Box>
                    )}

                    {showCopyMessage && (
                        <Box sx={{ textAlign: 'center', mt: 2 }}>
                            {/* <Button onClick={handleCopyLink} sx={{ color: 'white', backgroundColor: 'black', '&:hover': { backgroundColor: '#cfcfcf' } }}>
                                {linkCopied ? 'Link Copied' : 'Click to Copy Link'}
                                <ContentCopy sx={{ ml: 1 }} />
                            </Button> */}

                            <Button
                                onClick={handleCopyLink}
                                sx={{
                                    color: 'white',
                                    backgroundColor: '#484848',
                                    '&:hover': {
                                        backgroundColor: '#5e5e5e',
                                    },
                                    transition: 'background-color 0.3s ease-in-out',
                                    '&:active': {
                                        backgroundColor: 'black',
                                    },
                                    '&:focus': {
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                {linkCopied ? 'Link Copied' : 'Click to Copy Link'}
                                <ContentCopy sx={{ ml: 1 }} />
                            </Button>
                        </Box>
                    )}
                </Box>
            </Box>

            <Box sx={{
                maxWidth: '800px',
                // mx: 'auto', 
                // p: { xs: 2, md: 4 }, 
                mx: { xs: '1rem', sm: '4rem', md: '6rem', lg: '7rem' },
                p: { xs: 2, md: 2 },
                mt: 4
            }}
            >
                <Typography variant="h5">
                    Leave a Comment
                </Typography>
                <form onSubmit={handleCommentSubmit} noValidate>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Your Comment"
                        value={commentText}
                        onChange={(e) => setCommentText(e.target.value)}
                        multiline
                        rows={4}
                        sx={{ mb: 2, borderRadius: '10rem' }}
                    />
                    <Button type="submit" variant="contained" sx={{ mt: 2, borderRadius: '1.2rem' }}>
                        Submit
                    </Button>
                    {commentMessage && (
                        <Typography sx={{ mt: 2, backgroundColor: '#cfcfcf', borderRadius: '1.2rem', p: 1, textAlign: 'center' }}>
                            {commentMessage}
                        </Typography>
                    )}
                </form>

                <Typography variant="h6" sx={{ mt: 4 }}>
                    Comments ({comments.length})
                </Typography>

                {/* Comments List */}
                <Box sx={{ maxHeight: 300, overflow: 'auto', mt: 2 }}>
                    {comments.map((comment, index) => (
                        <Typography key={index} sx={{ mt: 1 }}>
                            {comment}
                        </Typography>
                    ))}
                    {comments.length === 0 && (
                        <Typography>No comments yet.</Typography>
                    )}
                </Box>

                <Button variant="contained" color="primary" onClick={handleBack} startIcon={<ArrowBack />}
                    sx={{
                        display: 'flex',
                        placeContent: 'center',
                        margin: 'auto',
                        mt: 5,
                        borderRadius: 10,
                        transition: 'background-color 0.3s ease',
                        ':hover': {
                            backgroundColor: '#f39c12',
                            color: 'white',
                        },
                    }}>
                    Back
                </Button>
            </Box>

            {/* Newsletter Sign-Up Section */}
            <Box component="form" onSubmit={handleNewsletterSubmit} sx={{
                position: { xs: 'static', md: 'absolute' },
                top: { md: 200 },
                right: { md: 10 },
                width: { xs: '90%', md: 300 },
                border: '2px solid #cdcfd2',
                borderRadius: '2rem',
                p: 2,
                mt: { xs: 3, md: 5, lg: 10 },
                mb: { xs: 2, md: 0 },
                mx: { xs: 2, md: 2 },
                backgroundColor: 'white',
                zIndex: 10
            }}>

                <Typography variant="h6" sx={{ mb: 2 }}>SIGN UP FOR BEADS NEWSLETTERS</Typography>
                <TextField label="First Name" variant="outlined" fullWidth sx={{ mb: 1 }} value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                <TextField label="Last Name" variant="outlined" fullWidth sx={{ mb: 1 }} value={lastName} onChange={(e) => setLastName(e.target.value)} required />
                <TextField label="Email Address" variant="outlined" fullWidth sx={{ mb: 2 }} value={email} onChange={(e) => setEmail(e.target.value)} required type="email" />

                <Button type="submit" variant="contained" fullWidth sx={{
                    // color: '#f39c12',
                    borderRadius: '2rem',
                    height: '42px',
                    ':hover': {
                        borderColor: '#f39c12',
                        backgroundColor: '#f39c12',
                        color: '#fff'
                    },
                }}>
                    Subscribe Now
                </Button>

                {newsletterMessage && (
                    <Typography sx={{ mt: 2, backgroundColor: '#cfcfcf', borderRadius: '1.2rem', p: 1, textAlign: 'center' }}>
                        {newsletterMessage}
                    </Typography>
                )}
            </Box>

            {/* <FooterOne /> */}
        </Box>
    );
};

export default BeadsConceptNote;
